export default __webpack_public_path__ + "static/media/776.91fab293.gif";